import React, { useState } from 'react'
import { useContext } from 'react'
import { LocalizationContext } from 'src/consumer/context/LocalizationContext'
import {
  GiftCardOptionsWrapper,
  GiftCardOptionsHeader,
  GiftCardHomepageWrapper,
  GiftCardHomepageHeader,
  GiftCardHomepageContent,
  GiftCardHomepageButtons,
  GiftCardOptionsButton,
  GiftCardOptionsLink,
  GiftCardRedeemLink,
} from './GiftCardHomepageStyles'
import PublicAppHeader from 'src/consumer/components/PublicAppHeader'
import { ClubbedAuthModal } from 'src/consumer/components/SignIn/ClubbedAuthComponents'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'

const GiftCardHomepage = () => {
  const { profileData } = useContext(ProfileContext)
  const { localizedDataLoading, localizedData, localizedDataError } =
    useContext(LocalizationContext)

  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('login')

  const pageId = 'giftPage'
  const localizedStrings = localizedData?.[pageId]

  const giftHeading =
    localizedStrings?.gift_page_screen_title || 'Gift Delivered,\nHappiness Created'
  const giftSubheading =
    localizedStrings?.gift_page_screen_subtitle ||
    'Creating Happiness for your loved ones is not Difficult,\nBuy an AUMHUM Gift card and make everyone smile.'

  const decidedCountryCode =
    profileData?.location?.countryCode || localStorage.getItem('countryCode')

  return (
    <>
      <PublicAppHeader
        config={{ showLinks: true }}
        loginFunction={() => {
          setTypeOfClubbedAuthModal('login')
          setShowClubbedAuthModal(true)
        }}
        registerFunction={() => {
          setTypeOfClubbedAuthModal('signup')
          setShowClubbedAuthModal(true)
        }}
      />

      <SEOComponent
        title="Gift AUMHUM to Your Loved Ones | AUMHUM"
        description={"Gift your loved ones AUMHUM's premier experiences for enhanced mental well-being and holistic care."}
        keywordsArr={['Gift Card', 'Health Support', 'gift']}
      />

      <GiftCardHomepageWrapper>
        <GiftCardHomepageHeader>
          {giftHeading.split('\\n').map((heading, index) => {
            return <div key={index}>{heading}</div>
          })}
        </GiftCardHomepageHeader>
        <GiftCardHomepageContent>
          {giftSubheading.split('\\n').map((subheading, index) => {
            return <div key={index}>{subheading}</div>
          })}
        </GiftCardHomepageContent>
        <GiftCardHomepageButtons>
          <GiftCardOptionsButton
            onClick={() => {
              document.getElementById('gift-options').scrollIntoView()
            }}
          >
            <GiftCardOptionsLink>
              {localizedStrings?.gift_your_loved_ones || 'Gift your loved ones'}
            </GiftCardOptionsLink>
          </GiftCardOptionsButton>
          <div>
            <GiftCardRedeemLink to="/gift-card/redeem">
              {localizedStrings?.redeem_gift_card || 'Redeem gift card'}
            </GiftCardRedeemLink>
          </div>
        </GiftCardHomepageButtons>
      </GiftCardHomepageWrapper>

      <GiftCardOptionsWrapper id="gift-options">
        <GiftCardOptionsHeader>
          {localizedStrings?.gift_options || 'Gift Options'}
        </GiftCardOptionsHeader>

        {decidedCountryCode === 'in' || decidedCountryCode === 'IN' ? (
          <>
            <div
              className="gift-up-target"
              data-site-id="4dfb93ae-171c-4d7d-babd-790a2f8fe08b"
              data-platform="Other"
            ></div>
            <script type="text/javascript">
              {(function (g, i, f, t, u, p, s) {
                g[u] =
                  g[u] ||
                  function () {
                    ;(g[u].q = g[u].q || []).push(arguments)
                  }
                p = i.createElement(f)
                p.async = 1
                p.src = t
                s = i.getElementsByTagName(f)[0]
                s.parentNode.insertBefore(p, s)
              })(window, document, 'script', 'https://cdn.giftup.app/dist/gift-up.js', 'giftup')}
              ;
            </script>
          </>
        ) : (
          <>
            <div
              className="gift-up-target"
              data-site-id="4d7ba16a-665a-4538-969a-3095d5b22c72"
              data-platform="Other"
            ></div>
            <script type="text/javascript">
              {(function (g, i, f, t, u, p, s) {
                g[u] =
                  g[u] ||
                  function () {
                    ;(g[u].q = g[u].q || []).push(arguments)
                  }
                p = i.createElement(f)
                p.async = 1
                p.src = t
                s = i.getElementsByTagName(f)[0]
                s.parentNode.insertBefore(p, s)
              })(window, document, 'script', 'https://cdn.giftup.app/dist/gift-up.js', 'giftup')}
            </script>
          </>
        )}
      </GiftCardOptionsWrapper>

      <ClubbedAuthModal
        open={showClubbedAuthModal}
        onClose={() => setShowClubbedAuthModal(false)}
        loginVariant={typeOfClubbedAuthModal === 'login'}
      />
    </>
  )
}

export default GiftCardHomepage
